<template>
  <div>
    <QHloading v-if="QHloading"></QHloading>
    <div class="container" :style="{ transform: 'scale(' + (autoWidows || 1) + ')', top: top + 'px', left: left + 'px' }">
      <div class="headerBox"><a href="http://rwbzx.xunji666.com"> {{$getCityFuqin('name')}}装修垃圾清运服务平台</a></div>
      <div class="addressBox flex-between">
        <div class="li flex-center">
          <div class="box1 FTC4 iconfont  icon-gongzuoshijian"></div>
          <div class="box2 FTC4">
            数据更新于<span style="font-size: 14px">{{ $timeFmt(Total.time, "YYYY-MM-DD HH:mm") }}</span>
          </div>
        </div>
        <div class="li li3 flex-center on" v-if="isRefreshS">
          <div class="box1 FTC4 iconfont icon-jiazai"></div>
          <div class="box2 FTC4">刷新</div>
        </div>
        <div class="li li3 flex-center" @click="getTotal(true)" v-else>
          <div class="box1 FTC4 iconfont icon-jiazai"></div>
          <div class="box2 FTC4">刷新</div>
        </div>
      </div>
      <div class="qiehuang" > <a href="http://rwb.xunji666.com"><span class="FTC1">建筑大屏</span></a></div>
      <div class="loginOut" @click="$loginOut()"><span class="FTC1">退出</span></div>
      <!---layoutLeft-->
      <div class="layoutLeft">
        <div class="blockA QHblock">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em style="font-size: 20px">{{ year }}</em>
              <em>年</em>
              <em>{{$getCityFuqin('name')}}</em>
              <em>排放统计</em>
            </span>
          </div>
          <div class="ContentBox">
            <div class="box1">
              <div class="li li1">
                <div class="boxTxt" @click="$QHopen.url('/electronicbillPFZL?year='+year, 99)">
                  <p class="p1">排放总量</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.PFZL }}<i>m³</i></span>
                  </p>
                </div>
              </div>
              <div class="li li2" @click="$QHopen.url('/electronicbillPFLD?year='+year, 99)">
                <div class="boxTxt">
                  <p class="p1">排放联单</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.PFLD }}<i>联</i></span>
                  </p>
                </div>
              </div>
            </div>
            <div class="box2" id="echartsNowYearAllMonth"></div>
          </div>
        </div>
        <div class="blockB QHblock">
          <div class="ContentBox flex-between">
            <div class="box box1" @click="$QHopen.url('/orguserlist?year='+year, 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.ZCYH }}<i class="QHjiliang"></i></span>
              </p>
              <p class="p1">总注册用户</p>
            </div>
            <div class="box box2" @click="$QHopen.url('/orgshhz?type=100', 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.ZCQYYH }}<i class="QHjiliang"></i></span>
              </p>
              <p class="p1">合作商体</p>
            </div>
            <div class="box box3" @click="$QHopen.url('/orgjmyh?type=200', 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.ZCJMYH }}<i class="QHjiliang"></i></span>
              </p>
              <p class="p1">居民用户</p>
            </div>
          </div>
          <div class="ContentBoxtwo flex-between">
            <div class="box box1" @click="$QHopen.url('/electronicbillPFZL?year='+year, 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.PFZL }}<i class="QHjiliang">方</i></span>
              </p>
              <p class="p1">总清运车方</p>
            </div>
            <div class="box box2" @click="$QHopen.url('/electronicbillPFLD?year='+year, 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.PFLD }}<i class="QHjiliang">联</i></span>
              </p>
              <p class="p1">总电子联单量</p>
            </div>
            <div class="box box3" @click="$QHopen.url('/filing?year='+year, 99)">
              <p class="p2 FTC3">
                <span class="s2">{{ Total.ZXBAL }}<i class="QHjiliang">次</i></span>
              </p>
              <p class="p1">总备案量</p>
            </div>
          </div>
        </div>
         <div class="blockC QHblock">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em>{{$getCityFuqin('name')}}</em>
              <em>排放单位</em>
            </span>
            <div style="position: relative">
              <Dropdown>
                <span class="s2 Qhxialas">企业组织</span>
               
              </Dropdown>
              <!-- <Dropdown >
                <span class="s2 Qhxialas" @click="getPFLX(200)">个人组织</span>
               
              </Dropdown> -->
            </div>
          </div>
          <div class="ContentBox">
            <ul class="flex-between">
              <li class="flex-center-col li1" :class="'li' + (index + 1)" v-for="(item, index) in Total['PFLX']['list']" :key="index">
                <div class="box1">
                  <em class="FTC3">{{ item.count }}</em
                  ><font></font>
                </div>
                <div class="box2">
                  <div class="bar" :style="'height:' + (item.count / Total['PFLX']['total']) * 100 + '%'"></div>
                </div>
                <div class="box3">{{ item.name }}</div>
              </li>
            </ul>
          </div>
        </div>


        <div class="blockD QHblock">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em>{{$getCityFuqin('name')}}</em>
              <em>综合数据统计</em>
            </span>
          </div>
          <div class="ContentBox">
            <div class="box1">
              <div class="li li1" @click="$QHopen.url('/orgduifanglist', 99)">
                <div class="boxTxt" >
                  <p class="p1">临时收集点</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.DFDWZL }}<i>个</i></span>
                  </p>
                </div>
              </div>
              <div class="li li2"  @click="$QHopen.url('/orgpaifang?yichangType=100', 99)">
                <div class="boxTxt">
                  <p class="p1">排放单位</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.PFDWZL }}<i>个</i></span>
                  </p>
                </div>
              </div>
               <div class="li li3" @click="$QHopen.url('/orgfj?type=300', 99)">
                <div class="boxTxt" >
                  <p class="p1">分拣中心</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.FJDWZL }}<i>个</i></span>
                  </p>
                </div>
              </div>
              <div class="li li4" @click="$QHopen.url('/orgzycz?type=200', 99)">
                <div class="boxTxt">
                  <p class="p1">资源化处理厂</p>
                  <p class="p2">
                    <span class="FTC1">{{ Total.ZYCLZL }}<i>个</i></span>
                  </p>
                </div>
              </div>
              </div>
          </div>
        </div>

     
      </div>
      <!---layoutLeft end-->

      <!---layoutCenter-->
      <div class="layoutCenter">
        <div class="leftBox">
          <div class="box box1 flex-between on" @click="$alert('您的账号权限可查看'+$getCityFuqin('name')+'清运数据')">
            <span class="FTC4">{{$getCityFuqin('name')}}</span>
            <i class="iconfont icon-chengshi flex-center FTC4"></i>
          </div>
          <div class="box flex-between" @click="$QHopen.url('/map', 1300)">
            <span class="FTC4">排收坐标分布</span>
            <i class="iconfont icon-zuobiao flex-center FTC4"></i>
          </div>
          <div class="box flex-between" @click="$QHopen.url('/mapXianlu', 1300)">
            <span class="FTC4">清运线路分布</span>
            <i class="iconfont icon-luxian flex-center FTC4"></i>
          </div>
          <div class="box flex-between" @click="$QHopen.url('/mapReli', 1300)">
            <span class="FTC4">清运热力分布</span>
            <i class="iconfont icon-reli_APreli flex-center FTC4"></i>
          </div>
          <div class="box box1" style="padding:0;">
            <Dropdown>
              <div class="flex-between" style="padding:8px;">
                <span class="FTC4"><font>{{year}}</font>年数据</span>
                <i class="iconfont icon-xiala flex-center FTC4" style="font-size: 12px;margin-left:13px;"></i>
              </div>
              <DropdownMenu slot="list">
              <DropdownItem v-for="(item, index) in $getYear('list')" :key="index">
                <p @click="getTotalByYear(item)">{{ item }}年</p>
              </DropdownItem>
            </DropdownMenu>
            </Dropdown>
          </div>
        </div>
            
        <div id="geoMapA" class="geoMapA"></div>
        <div class="bottomBox flex-between">
          <div class="box box1" @click="$QHopen.url('/box', 99)">
            <div class="boxTxt">
              <em>智能车厢</em>
              <font class="FTC2">{{ Total.ZNCX }}<i>个</i></font>
            </div>
          </div>
          <div class="box box2" @click="$QHopen.url('/car', 99)">
            <div class="boxTxt">
              <em>运输车辆</em>
              <font class="FTC2">{{ Total.CL }}<i>辆</i></font>
            </div>
          </div>
          <div class="box box3" @click="$QHopen.url('/orgyunshu', 99)">
            <div class="boxTxt">
              <em>运输企业</em>
              <font class="FTC2">{{ Total.YSDW }}<i>个</i></font>
            </div>
          </div>
          <div class="box box4" @click="$QHopen.url('/electronicbillZXCL', 99)">
            <div class="boxTxt">
              <em>在线车辆</em>
              <font class="FTC2">{{ Total.ZXCL }}<i>辆</i></font>
            </div>
          </div>
          <div class="box box5" @click="$QHopen.url('/electronicbillJRLD', 99)">
            <div class="boxTxt">
              <em>今日清运</em>
              <font class="FTC2">{{ Total.JRQY }}<i>m³</i></font>
            </div>
          </div>
          <div class="box box6" @click="$QHopen.url('/electronicbillJRLD', 99)">
            <div class="boxTxt">
              <em>今日联单</em>
              <font class="FTC2">{{ Total.JRLD }}<i>联</i></font>
            </div>
          </div>
          <div class="box7"  @click="$QHopen.url('/electronicbillSSLD', 99)">
            <span class="FTC1">实时联单</span>
          </div>
        </div>
      </div>
      <!---layoutCenter end-->

      
      <!---layoutRight-->
      <div class="layoutRight">
        <div class="QHblock blockA">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em style="font-size: 20px">{{ year }}</em>
              <em>年</em>
              <em>{{$getCityFuqin('name')}}</em>
              <em>区域排名</em>
            </span>
          </div>
          <div class="ContentBox">
            <div class="box2" id="echartsQYPM"></div>
          </div>
        </div>
        <div class="blockB QHblock">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em style="font-size: 20px">{{ year }}</em>
              <em>年</em>
              <em>{{$getCityFuqin('name')}}</em>
              <em>处置单位排名</em>
            </span>
          </div>
          
          <div class="ContentBox">
            <div class="boxLevel1" @mouseleave="resetScroll">
              <vue-seamless-scroll :data="Total.CZPM || []">
                <ul class="boxLevel2">
                  <li class="li flex-center-y" v-for="(item, index) in Total.CZPM" :key="index">
                    <span
                      ><i>{{ index + 1 }}</i></span
                    >
                    <span class="oe1">{{ item.orgName }}</span>
                    <span class="FTC1">{{ item.count }}m³</span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>

        <div class="blockB QHblock">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em style="font-size: 20px">{{ year }}</em>
              <em>年</em>
              <em>{{$getCityFuqin('name')}}</em>
              <em>排放单位排名</em>
            </span>
          </div>
          
          <div class="ContentBox">
            <div class="boxLevel1" @mouseleave="resetScroll">
              <vue-seamless-scroll :data="Total.PFPM || []">
                <ul class="boxLevel2">
                  <li class="li flex-center-y" v-for="(item, index) in Total.PFPM" :key="index">
                    <span
                      ><i>{{ index + 1 }}</i></span
                    >
                    <span class="oe1">{{ item.name }}</span>
                    <span class="FTC1">{{ item.count }}m³</span>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
        
        
        <div class="QHblock blockC">
          <div class="h1 flex-between">
            <span class="s1 FTC4">
              <em>{{$getCityFuqin('name')}}</em>
              <em>异常联单</em>
            </span>
          </div>
          <div class="ContentBox">
            <div class="ul">
              <div class="box box1 hover" @click="$QHopen.url('/electronicbillYCLD?yichangType=100', 99)">
                <div>
                  <p class="p1">排放异常</p>
                  <p class="p2 FTC1">{{ Total.YCPF }}</p>
                </div>
              </div>
              <div class="box box2 hover" @click="$QHopen.url('/electronicbillYCLD?yichangType=200', 99)">
                <div>
                  <p class="p1">接收异常</p>
                  <p class="p2 FTC1">{{ Total.YCJS }}</p>
                </div>
              </div>
              <div class="box box3 hover" @click="$QHopen.url('/electronicbillYCLD?yichangType=300', 99)">
                <div>
                  <p class="p1">运输异常</p>
                  <p class="p2 FTC1">{{ Total.YCYS }}</p>
                </div>
              </div>
              <div class="box box4 hover" @click="$QHopen.url('/electronicbillYCLD?yichangType=500', 99)">
                <div>
                  <p class="p1">异常联单</p>
                  <p class="p2 FTC1">{{ Total.YCSS }}</p>
                </div>
              </div>
              <div class="box box5 hover" @click="$QHopen.url('/electronicbillYCLD?yichangType=400', 99)">
                <div>
                  <p class="p1">平台已核</p>
                  <p class="p2 FTC1">{{ Total.YCSL }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!---layoutRight end-->
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import "./style/index.less";
import { geoMapA } from "./js/geoMapA.js";
import { echartsNowYearAllMonth } from "./js/echartsNowYearAllMonth.js";
import { echartsQYPM } from "./js/echartsQYPM.js";
import { windowAuto, addResizeListener, removeResizeListener } from "./js/windowAuto.js";

export default {
  components: { vueSeamlessScroll },
  data() {
    return {
      QHloading: true,
      isRefreshS: false,
      //大屏定位于缩放
      top: 0,
      left: 0,
      autoWidows: 1, //缩放比例
      year: this.$getYear("year"),
      PFgarbageName: "工程渣土",
      CZgarbageName: "企业组织",

      //数据
      Total: {
        //排放统计
        PFZL: 0,
        PFLD: 0,
        PFDWZL: 0,
        FJDWZL: 0,
        ZYCLZL: 0,
        DFDWZL: 0,
        nowYearAllMonth: [],
        nowYearAllQYPM:[],
        //排放单位
        ZCYH: 0,
        ZCQYYH: 0,
        ZCJMYH: 0,
        ZXBAL: 0,
        //排放类型
        PFLX: {
          list: "",
          total: 0,
        },
        //排放排名
        PFPM: [],
        //运输信息
        CB: 0,
        ZNCX:0,
        CL: 0,
        YSDW: 0,
        ZXCL: 0,
        JRQY: 0,
        JRLD: 0,
        GQDW:[],
        //处置单位
        CZDWRL:0,
        CZDWSY:0,
        CZDWSYL:0,
        CZDWZL:0,
        CZDWPM:[],
        ZYLYL:0,
        ZHLYL:0,
        //处置排名
        CZPM: "",
        //异常联单
        YCPF: 0,
        YCJS: 0,
        YCYS: 0,
        YCSL: 0,
        YCSS: 0,
        //统计时间
        time: "",
      },
    };
  },
  //异常联单

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    var that = this;
    //获取全部数据
    this.getTotal();

    //大屏尺寸响应启动
    windowAuto(this);

    //大屏尺寸变化启动
    addResizeListener(this);

    //数据热更新
    setInterval(() => {
      that.getTotalHot();
    }, 60000);
  },

  // +----------------------------------------------------------------------
  // | beforeDestroy
  // +----------------------------------------------------------------------
  beforeDestroy() {
    //大屏尺寸响应销毁
    removeResizeListener(this);
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 无缝滚动兼容鼠标滚动
    // +----------------------------------------------------------------------
    resetScroll(event) {
      // 获取触发事件的元素（即 .boxLevel1）
      const target = event.currentTarget;
      target.scrollTop = 0; // 将滚动条位置重置为 0
    },

    // +----------------------------------------------------------------------
    // | 获取全部数据
    // +----------------------------------------------------------------------
    getTotal(isRefresh) {
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getTotal,
        parameter: {
          year: that.year,
          isRefresh: isRefresh || "",
          PFgarbageName: that.PFgarbageName,
          CZgarbageName: that.CZgarbageName,
        },
      };
      that.isRefreshS = true;
      this.$httpsApi(https, function (res) {
        that.QHloading = false;
        that.isRefreshS = false;
        that.Total = that.$fieldUpdate(that.Total, res.data);
        echartsNowYearAllMonth(that, res.data.nowYearAllMonth);
        echartsQYPM(that, res.data.nowYearAllQYPM);
        geoMapA(that, res.data.GQDW);
      });
    },

    // +----------------------------------------------------------------------
    // | 获取全部数据
    // +----------------------------------------------------------------------
    getTotalHot() {
      var that = this;
      var https = {
        type: "isApi",
        api: this.$api.getTotalHot,
        parameter: {
          year: that.year,
          PFgarbageName: that.PFgarbageName,
          CZgarbageName: that.CZgarbageName,
        },
      };
      this.$httpsApi(https, function (res) {
        that.QHloading = false;
        that.Total = that.$fieldUpdate(that.Total, res.data);
      });
    },

    // +----------------------------------------------------------------------
    // | 数据刷新
    // +----------------------------------------------------------------------
    getTotalReset() {
      var that = this;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getTotal,
        parameter: {
          year: that.year,
          PFgarbageName: that.PFgarbageName,
          CZgarbageName: that.CZgarbageName,
        },
      };
      this.$httpsApi(https, function (res) {
        that.Total = that.$fieldUpdate(that.Total, res.data);
        that.$msg("数据刷新成功", "success");
        echartsNowYearAllMonth(that, res.data.nowYearAllMonth);
        echartsQYPM(that, res.data.nowYearAllQYPM);
      });
    },

    // +----------------------------------------------------------------------
    // | 按年份获取数据
    // +----------------------------------------------------------------------
    getTotalByYear(year) {
      var that = this;
      that.year = year;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getTotalByYear,
        parameter: {
          year: year,
        },
      };
      this.$httpsApi(https, function (res) {
        that.Total = that.$fieldUpdate(that.Total, res.data);
        that.$msg("数据获取成功", "success");
        echartsNowYearAllMonth(that, res.data.nowYearAllMonth);
        echartsQYPM(that, res.data.nowYearAllQYPM);
      });
    },

    // +----------------------------------------------------------------------
    // | 更新局部数据(排放排名)
    // +----------------------------------------------------------------------
    getPFPM(PFgarbageName) {
      var that = this;
      that.PFgarbageName = PFgarbageName;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getPFPM,
        parameter: {
          isAjax: true,
          PFgarbageName: PFgarbageName,
        },
      };
      this.$httpsApi(https, function (res) {
        that.Total = that.$fieldUpdate(that.Total, res.data);
        console.log(that.Total);
        echartsNowYearAllMonth(that, res.data.nowYearAllMonth);
        echartsQYPM(that, res.data.nowYearAllQYPM);
      });
    },

    // +----------------------------------------------------------------------
    // | 更新局部数据(处置排名)
    // +----------------------------------------------------------------------
    getPFLX(formType) {
      
      var that = this;
      that.formType = formType;
      var https = {
        type: "isApi",
        isLoading: "isLoadingPop",
        api: this.$api.getPFLX,
        parameter: {
          formType: formType,
          isAjax: true,
          
         
        },
      };
      this.$httpsApi(https, function (res) {
        that.Total = that.$fieldUpdate(that.Total, res.data);
        console.log(that.Total);
        echartsNowYearAllMonth(that, res.data.nowYearAllMonth);
      });
    },
  },
};
</script>